import BreakreminderLogo from '../assets/logo_breakreminder.svg'
import { Link } from 'react-router-dom'
import React from 'react'
import styled from 'styled-components/macro'

const StyledLink = styled(Link)`
  transition: filter 100ms ease;
  display: inline-block;
  user-select: none;
  height: 100%;

  &:focus,
  &:hover {
    outline: none;
    filter: grayscale(100%);
  }

  > img {
    height: 100%;
  }
`

export default props => (
  <StyledLink { ...props }>
    <img src={ BreakreminderLogo } alt='Logo breakreminder'/>
  </StyledLink>
)
